module.exports = __webpack_public_path__ + "954bc3536cd1ecb247f3fe91152773f8.svg";